<template>
    <span v-if="showBadge" class="count-badge" :aria-label="props.ariaLabel">
        {{ countLabel }}
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
    count: number;
    ariaLabel?: string;
    showCountWhenZero?: boolean;
}>(), {
    ariaLabel: 'Count',
    showCountWhenZero: false,
});

const countLabel = computed<string>(() => (props.count > 99 ? '99+' : `${props.count}`));
const showBadge = computed<boolean>(() => props.count > 0 || props.showCountWhenZero);
</script>

<style scoped lang="scss">
.count-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.8rem;
    min-height: 1.4rem;
    background-color: var(--accentColour);
    border-radius: var(--borderRadiusInner);
    color: var(--neutral0);
    font-size: var(--extraSmallFontSize);
    font-weight: var(--extraBoldFontWeight);
    line-height: 1;
    padding: 0 var(--smallSpacing);
    white-space: nowrap;
}
</style>
